/**
 * Display label for a remaining-time breakdown row.
 */
export function formatBreakdownLabel(item) {
  if (!item) return '';
  if (item.path?.length > 0) {
    return `${item.path.join(' › ')} › ${item.name}`;
  }
  return item.name;
}
